import { render, staticRenderFns } from "./ModalVerificarPrivado.vue?vue&type=template&id=1bd245c9"
import script from "./ModalVerificarPrivado.vue?vue&type=script&lang=js"
export * from "./ModalVerificarPrivado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports